import getConfig from 'next/config';

const runtimeConfig = getConfig() ? getConfig().publicRuntimeConfig : {};

const { IMGIX_DOMAIN, AWS_BUCKET_DOMAIN } = runtimeConfig;

export default (url) =>
  decodeURI(url).replace('.eu-west-1', '').replace(AWS_BUCKET_DOMAIN, IMGIX_DOMAIN);
